namespace RioERP.Wallet {
    export interface CreditJournalRow {
        Id?: string;
        Name?: string;
        Description?: string;
        Kind?: number;
    }

    export namespace CreditJournalRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'Wallet.CreditJournal';
        export const lookupKey = 'Wallet.CreditJournal';

        export function getLookup(): Q.Lookup<CreditJournalRow> {
            return Q.getLookup<CreditJournalRow>('Wallet.CreditJournal');
        }
        export const deletePermission = 'Wallet:WalletManagement:Modify';
        export const insertPermission = 'Wallet:WalletManagement:Modify';
        export const readPermission = 'Wallet:WalletManagement:View';
        export const updatePermission = 'Wallet:WalletManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            Description = "Description",
            Kind = "Kind"
        }
    }
}
